import { PAGE_TYPE } from "@/meta/common";
import type { RouteRecordRaw } from "vue-router";

const lianYunUser: RouteRecordRaw[] = [
    {
        path: "/lianYunUser",
        name: "LianYunUser",
        component: () => import("@/layouts/index.vue"),
        meta: {
            title: "用户管理"
        },
        children: [
            {
                path: "infoManage",
                name: "InfoManage",
                component: () => import("@/views/pages/lianYunUser/infoManage/infoManage.vue"),
                meta: {
                    icon: "icon-user-3",
                    title: "用户列表",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SS_CUSTOMER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_SS_CUSTOMER_W"
                        }
                    ]
                }
            },
            {
                path: "userInfo",
                name: "UserInfo",
                component: () => import("@/views/pages/lianYunUser/infoManage/infoDetail/index.vue"),
                meta: {
                    title: "查看用户信息",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InfoManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SS_CUSTOMER_R"
                        }
                    ]
                }
            },
            {
                path: "communicateRecordDetail",
                name: "CommunicateRecordDetail",
                component: () =>
                    import("@/views/pages/lianYunUser/infoManage/infoDetail/components/interactionRecord/record/detail.vue"),
                meta: {
                    title: "用户沟通记录详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InfoManage",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SS_CUSTOMER_W"
                        }
                    ]
                }
            },
            {
                path: "AddCommunicateRecord",
                name: "AddCommunicateRecord",
                component: () =>
                    import("@/views/pages/lianYunUser/infoManage/infoDetail/components/interactionRecord/record/form.vue"),
                meta: {
                    title: "新增用户沟通记录",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InfoManage",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SS_CUSTOMER_W"
                        }
                    ]
                }
            },
            {
                path: "editCommunicateRecord",
                name: "EditCommunicateRecord",
                component: () =>
                    import("@/views/pages/lianYunUser/infoManage/infoDetail/components/interactionRecord/record/form.vue"),
                meta: {
                    title: "修改用户沟通记录",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InfoManage",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SS_CUSTOMER_W"
                        }
                    ]
                }
            },
            {
                path: "institutionApply",
                name: "InstitutionApply",
                component: () => import("@/views/pages/lianYunUser/institutionApply/index.vue"),
                meta: {
                    title: "企业认证审核",
                    pageType: PAGE_TYPE.LIST.code,
                    icon: "icon-Frame5",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_SS_ORG_REVIEW"
                        },
                        {
                            label: "审核",
                            value: "ROLE_SS_ORG_DEAL"
                        }
                    ]
                }
            },
            {
                path: "institutionApply/info/:id",
                name: "InstitutionDetail",
                component: () => import("@/views/pages/lianYunUser/institutionApply/institutionDetail/index.vue"),
                meta: {
                    title: "查看企业认证详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InstitutionApply",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_SS_ORG_REVIEW"
                        }
                    ]
                }
            },
            {
                path: "institutionApply/audit/:id",
                name: "InstitutionAudit",
                component: () => import("@/views/pages/lianYunUser/institutionApply/institutionDetail/index.vue"),
                meta: {
                    title: "审核企业认证",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InstitutionApply",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_SS_ORG_REVIEW"
                        }
                    ]
                }
            },
            {
                path: "institutionApply/form/:id",
                name: "InstitutionForm",
                component: () => import("@/views/pages/lianYunUser/institutionApply/form/index.vue"),
                meta: {
                    title: "修改企业认证",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InstitutionApply",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_SS_ORG_DEAL"
                        }
                    ]
                }
            },
            {
                path: "memberLevel",
                name: "MemberLevel",
                component: () => import("@/views/pages/lianYunUser/memberLevel/memberLevel.vue"),
                meta: {
                    title: "会员等级配置",
                    activeMenu: "MemberLevel",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_VIP_LEVEL"
                        }
                    ]
                }
            },
            {
                path: "activationCode",
                name: "ActivationCode",
                component: () => import("@/views/pages/lianYunUser/activationCode/index.vue"),
                meta: {
                    icon: "icon-Frame-2",
                    title: "会员激活码",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_CDKEY_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_CDKEY_W"
                        }
                    ]
                }
            },
            {
                path: "memberLevelinfo",
                name: "MemberLevelinfo",
                component: () => import("@/views/pages/lianYunUser/memberLevel/modifyMerber/index.vue"),
                meta: {
                    title: "权限设置",
                    isNotShowHeader: true,
                    hidden: true,
                    activeMenu: "MemberLevel",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_VIP_LEVEL"
                        }
                    ]
                }
            },
            {
                path: "recharge",
                name: "Recharge",
                component: () => import("@/views/pages/lianYunUser/rechargeManage/index.vue"),
                meta: {
                    icon: "icon-Frame-3",
                    title: "会员充值记录",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_ORDER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_ORDER_W"
                        }
                    ]
                }
            },
            {
                path: "activationCodeAdd",
                name: "ActivationCodeAdd",
                component: () => import("@/views/pages/lianYunUser/activationCode/edit.vue"),
                meta: {
                    icon: "icon-user-3",
                    title: "新增激活码",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "ActivationCode",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SS_CUSTOMER_W"
                        }
                    ]
                }
            }
        ]
    }
];

export default lianYunUser;
